export default "__VITE_ASSET__BmXycZNt__"